class Submit {
  constructor(element$) {
    this._element$ = element$;
    this.submitButton$ = this._element$.find('[data-voc-sportsdata-form-submit-button]');
    const submitUrl = this._element$.attr('data-voc-sportsdata-form-submit-url');

    this.submitButton$.on('click', (event) => {
      event.preventDefault();
      this.onSubmit(submitUrl);
    });
  }

  onSubmit(submitUrl){
    const imputList$ = this._element$.find('[data-voc-sportsdata-form-submit-input]');
    let isUrlParameters = false;

    imputList$.each(function() {
      let imputKey = this.getAttribute('data-voc-sportsdata-form-submit-input');
      const imputValue = this.value;
      isUrlParameters =  imputValue == '' ? isUrlParameters : true;
      imputKey = imputValue == '' ? imputKey+'/' : imputKey;
      submitUrl = submitUrl.replace(imputKey, imputValue);
    });
    submitUrl +='#jjoo';
    window.location = submitUrl;
  }
}

export default Submit;



// WEBPACK FOOTER //
// ./src/views/submit.js